export default function() {
  return new Worker(__webpack_public_path__ + "search.worker-d8cabec8fcc4416a3f2c.worker.js");
}
